import React, { Component } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';

import { Card, CardContent, Columns, Column, MuiTitle } from 'src/ui/mui-ui-kit';;
import Masonry from 'react-masonry-component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from 'lodash';
import { toast } from 'react-toastify';

import {
  setBreadcrumbs,
  reduceServerErrors,
  InnerLoader,
  UiToastAdapter,
  GuidelinesCard,
  // NextButton,
} from 'src/ui';
import { getUser } from 'src/user';
import {
  getAccount,
  fetchAccount,
  signConsent,
  getFormData,
  fetchFormData,
} from 'src/account';

import { getConsentTypesForAccount } from '../services';
import { SubmitConsentModal } from '../components';

class ConsentsListPage extends Component {
  state = {
    loading: true,
    submittingConsent: undefined,
  };

  guidelines = [
    `In this section is listed all of the necessary documents requiring your consent during this process. After consenting you will be able to download the document for your own records or access them here even after your application process is complete.`,
    `Depending on the nature of the form you may be required to sign via Docusign or to initial after scrolling through the whole document.`,
    `If you have any questions please feel free to contact support.`,
  ];

  async componentDidMount() {
    const { setBreadcrumbs, user, fetchAccount, fetchFormData } = this.props;

    setBreadcrumbs([{ label: 'Consents', href: '/consents' }]);

    if (user.accountId) {
      await fetchAccount(user.accountId);

      const { account } = this.props;

      if (account.isError()) {
        reduceServerErrors(account);
      } else {
        const { account } = this.props;

        await fetchFormData(
          user.financialInstitutionId || account.financialInstitutions[0].id,
          user.accountId
        );

        const { formData } = this.props;
        if (formData.isError()) {
          reduceServerErrors(formData);
        }
      }
    }

    this.setState({ loading: false });
  }

  openModal = consent => {
    this.setState({ submittingConsent: consent });
  };

  onCancelSubmit = () => {
    this.setState({ submittingConsent: undefined });
  };

  onSubmit = async ({ initials }) => {
    const { user, signConsent } = this.props;
    const { submittingConsent } = this.state;

    await signConsent({
      accountId: user.accountId,
      consentTypeId: submittingConsent.id,
      initials,
    });

    const { account } = this.props;
    if (account.isError()) {
      return reduceServerErrors(account);
    }

    toast(UiToastAdapter('Consent signed successfully!', 'success'));
    this.onCancelSubmit();
    return undefined;
  };

  isConsentSigned(consent) {
    const { account } = this.props;
    const { consents } = account;

    return !!_.find(consents, { id: consent.id });
  }

  consentIcon(isSigned) {
    if (isSigned) {
      return (
        <span className="icon is-medium has-icon-gradient-bright">
          <FontAwesomeIcon icon={['fas', 'check-circle']} size="2x" />
        </span>
      );
    }
    return (
      <span className="icon is-medium has-text-grey-lighter">
        <FontAwesomeIcon icon={['fal', 'circle']} size="2x" />
      </span>
    );
  }

  render() {
    const { account, user, formData } = this.props;
    const { loading, submittingConsent } = this.state;

    const consentTypes = getConsentTypesForAccount(account, formData);

    return (
      <>
        <MuiTitle isSize="4" hasTextColor="info" tag="h2">
          Consents and Signatures
        </MuiTitle>
        <Columns>
          <Column>
            <Masonry className="columns consents-list">
              {consentTypes.length
                ? consentTypes.map((type, i) => {
                    const isSigned = this.isConsentSigned(type);
                    const cardClassName = isSigned ? 'is-signed' : '';

                    return (
                      <Column isSize="1/2" key={i}>
                        <Card
                          key={type.id}
                          className={cardClassName}
                          onClick={
                            !isSigned ? () => this.openModal(type) : null
                          }
                        >
                          <CardContent>
                            <Columns>
                              <Column isSize="narrow">
                                {this.consentIcon(isSigned)}
                              </Column>
                              <Column className="content">
                                <p className="title is-5 has-text-primary">
                                  {type.name}
                                </p>
                                <div
                                  className="subtitle is-size-7 has-text-grey-medium-dark"
                                  /* eslint-disable-next-line */
                                  dangerouslySetInnerHTML={{
                                    __html: type.shortDescription,
                                  }}
                                />
                              </Column>
                            </Columns>
                          </CardContent>
                        </Card>
                      </Column>
                    );
                  })
                : null}
            </Masonry>
            <InnerLoader visible={loading} />
            {/* <Columns isGapless>
              <Column>
                <NextButton to="/documents" isPrev>
                  Previous
                </NextButton>
              </Column>
              <Column>
                <NextButton to="/review" />
              </Column>
            </Columns> */}
          </Column>
          {!user.isBankAdmin && (
            <Column isSize="narrow">
              <GuidelinesCard guidelines={this.guidelines} />
            </Column>
          )}
        </Columns>
        <SubmitConsentModal
          consent={submittingConsent}
          onSubmit={this.onSubmit}
          onClickCancel={this.onCancelSubmit}
        />
      </>
    );
  }
}

ConsentsListPage.propTypes = {
  user: propTypes.object.isRequired,
  account: propTypes.object.isRequired,
  formData: propTypes.object.isRequired,
  setBreadcrumbs: propTypes.func.isRequired,
  fetchAccount: propTypes.func.isRequired,
  fetchFormData: propTypes.func.isRequired,
  signConsent: propTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    user: getUser(state),
    account: getAccount(state),
    formData: getFormData(state),
  };
}

const connectedConsentsListPage = connect(mapStateToProps, {
  setBreadcrumbs,
  fetchAccount,
  fetchFormData,
  signConsent,
})(ConsentsListPage);

export { connectedConsentsListPage as ConsentsListPage };
